var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"id":"appbar","color":"accent","height":"76px","elevation":"0","app":""}},[_c('div',{staticClass:"main ml-3"},[_c('h5',[_vm._v(_vm._s(_vm.getCurrentRoute))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }